import { Parse } from 'parse';
Parse.initialize(
  process.env.REACT_APP_APP_ID,
  process.env.REACT_APP_JAVASCRIPT_KEY,
  process.env.REACT_APP_MASTER_KEY
);
Parse.masterKey = process.env.REACT_APP_MASTER_KEY;
Parse.serverURL = process.env.REACT_APP_SERVER_URL;

class CustomUser extends Parse.User {
  constructor(attributes) {
    super(attributes);
  }
  async setRole(roleId) {
    console.log(roleId);
    var roleQuery = new Parse.Query(Parse.Role);
    const role = await roleQuery.get(roleId, { useMasterKey: true });
    // const role = await roleQuery.first({useMasterKey: true});
    // console.log(role);
    this.set('role', role);
    return role.get('name');
    // roleQuery = new Parse.Query(Parse.Role);
    // roleQuery.greaterThan("level", role.get("level"));
    // const roles = await roleQuery.find({useMasterKey: true});
    // for (let r of roles){
    // 	console.log(r.get("name"));
    // 	const acl = r.getACL();
    // 	acl.setReadAccess(this, true);
    // 	await r.save(null, {useMasterKey: true});
    // }
  }
  async setManager(userId) {
    if (userId) {
      const user = await new Parse.Query(CustomUser).get(userId, {
        useMasterKey: true
      });
      this.set('manager', user);
    } else {
      this.set('manager', Parse.User.current());
    }
  }
  async incrementLoginCount() {
    let currentCount = this.get('loginTimes') || 0;
    this.set('loginTimes', currentCount + 1);
    await this.save();
  }
  async setLastLogin() {
    this.set('lastLogin', new Date());
    await this.save();
  }
  async setOnline(online) {
    this.set('isOnline', online);
    await this.save();
  }
  async setManagerACL() {
    const manager = this.get('manager');
    await manager.fetch({ useMasterKey: true });
    console.log('***', this.getACL());
    const mergedPermissions = {
      ...{ [this.id]: { read: true, write: true } },
      ...manager.getACL().permissionsById
    };
    this.set('ACL', mergedPermissions);
    console.log('### mergedPermissions', mergedPermissions);
    await this.save(null, { useMasterKey: true });
  }
  async addToRole() {
    const role = this.get('role');
    await role.fetch({ useMasterKey: true });
    role.getUsers().add(this);
    await role.save(null, { useMasterKey: true });
  }
}

Parse.Object.registerSubclass('_User', CustomUser);

export { CustomUser };
